var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('create-button',{staticClass:"test-card card",attrs:{"is-disabled":_vm.isAnyRequestInProgress,"is-in-progress":_vm.requestsProgress.store,"click-handler":_vm.createTest,"title":_vm.trans.new_test_button_title}})}
var staticRenderFns = []

export { render, staticRenderFns }